export const padStart = (num) => {
    if (num >= 10) {
        return num
    }
    return `0${num}`
}
export function formatNumber (n) {
    const str = n.toString()
    return str[1] ? str : `0${str}`
}

export const handleSeconds = (time) => {
    const duration = parseInt(time)
    const seconds = padStart(duration % 60)
    const minutes = padStart(Math.floor(duration / 60))
    return minutes + ':' + seconds
}

export function formatActivityDate (time_str) {
    const date_str = time_str.substring(0, 10)
    const join_char = date_str.indexOf('-') > -1 ? '-' : '/'
    return date_str.split(join_char).map((item) => {
        return Number(item)
    }).join('.') + time_str.substring(10, 16)
}

export function formatTimeStr (time) {
    const second_time = 1000
    const min_time = 60 * second_time
    const hour_time = 60 * min_time
    const day_time = 24 *  hour_time
    const day = parseInt(time / day_time)
    const day_str = day ? `${day}天` : ''
    let spare_time = time % day_time
    const hour = parseInt(spare_time / hour_time)
    const hour_str = hour ? `${padStart(hour)}时` : ''
    spare_time = spare_time % hour_time
    const min = parseInt(spare_time / min_time)
    const min_str =  min ? `${padStart(min)}分` : ''
    spare_time = spare_time % min_time
    const second = parseInt(spare_time / second_time)
    const second_str =  second ? `${padStart(second)}秒` : ''
    return `${day_str}${hour_str}${min_str}${second_str}`
}

export function formatTime (date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    const t1 = [year, month, day].map(formatNumber).join('/')
    const t2 = [hour, minute, second].map(formatNumber).join(':')

    return `${t1} ${t2}`
}

export function throttle (fn, delay, isTimeStamp) {
    let timeout = null
    let start = 0
    return function () {
        return new Promise((resolve) => {
            if (isTimeStamp) {
                const now = new Date().getTime()
                if (now - start > delay) {
                    start = now
                    resolve(fn.apply(this, arguments))
                }
            } else {
                if (!timeout) {
                    setTimeout(() => {
                        timeout = null
                        resolve(fn.apply(this, arguments))
                    }, delay)
                }
            }
        })
    }
}

export const getWeekByDateStr = (str) => {
    const weeks = ['日', '一', '二', '三', '四', '五', '六']
    return `星期${weeks[new Date(str).getDay()]}`
}

export function accSub (arg1, arg2) {
    let r1, r2, m, n
    try {
        r1 = arg1.toString().split('.')[1].length
    }
    catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split('.')[1].length
    }
    catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

export const formatRate = (rate) => {
    const rates = rate.toFixed(4).split('.')
    let suffix = Number(rates[1]) === 0 ? 0 : (rates[1] / 10000).toString().split('.')[1]
    return rates[0] + '.' + suffix
}

export const formatNumberInput = (e) => {
    const { value } = e.target
    const num = Number(value)
    if (isNaN(num)) {
        return 0
    }
    return num
}

export const getLocalDate = (str) => {
    const [str1, str2] = str.split(' ')
    const [year, month, day] = str1.split('-')
    let rs = `${year}年${month}月${day}日`
    if (str2) {
        const [hour, minute, second] = str2.split(':')
        rs += `${hour}时${minute}分${second}秒`
    }
    return rs
}

export function debounce (func, wait = 100, immediate = false) {
    let timeout
    return function(...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        timeout = null
        if (!immediate) func.apply(this, args)
      }, wait)
      if (immediate && !timeout) func.apply(this, [...args])
    }
  }